import React from 'react';

var ArrowBottom = function ArrowBottom(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M12 11.586l6.293-6.293a1 1 0 0 1 1.414 1.414l-7 7a1 1 0 0 1-1.414 0l-7-7a1 1 0 0 1 1.414-1.414L12 11.586zM6 18a1 1 0 1 1-2 0 1 1 0 0 1 2 0zm14 0a1 1 0 1 1-2 0 1 1 0 0 1 2 0zM5 17h14v2H5v-2z",
    fill: "currentColor",
    fillRule: "nonzero"
  }));
};

ArrowBottom.defaultProps = {
  role: "img",
  viewBox: "0 0 24 24"
};
import iconHandler from './hoc';
export { ArrowBottom as icon };
export default iconHandler(ArrowBottom);


//////////////////
// WEBPACK FOOTER
// ./~/@jsluna/icons/dist/ArrowBottom.js
// module id = 576
// module chunks = 0